<template>
  <div>
    <b-form-group label="Descrição" label-for="input-description">
      <b-form-input
        type="text"
        id="input-nomeAcesso"
        placeholder="Informe a descrição da despesa"
        v-model="expense.description"
      />
    </b-form-group>
    <b-form-group label="Tipo da despesa" label-for="input-expenseType">
      <single-select
        :value.sync="expense.expenseType"
        :value-property="'value'"
        :options="expenseTypeOpt"
        :placeholder="'Selecione o tipo da despesa'"
      />
    </b-form-group>
    <b-form-group label="Centro de custo" label-for="input-typeOfApportionment">
      <cost-center-dropdown
        id="parentCostCenterId"
        :costCenterId.sync="expense.costCenterId"
      >
      </cost-center-dropdown>
    </b-form-group>
    <div v-if="expense.expenseType == 1">
      <b-form-group label="Data de início" label-for="input-initDate">
        <b-form-input
          type="date"
          id="input-initDate"
          placeholder="Informe o nome de acesso"
          v-model="expense.initDate"
        />
      </b-form-group>
      <b-form-group label="Data de fim" label-for="input-endDate">
        <b-form-input
          type="date"
          id="input-endDate"
          placeholder="Informe o nome de acesso"
          v-model="expense.endDate"
        />
      </b-form-group>
      <b-form-group label="Valor" label-for="input-endDate">
        <base-input-numeric id="value" :value.sync="expense.value">
        </base-input-numeric>
      </b-form-group>
    </div>
    <div v-if="expense.expenseType == 2">
      <b-form-group label="Rateio" label-for="input-apportionment">
        <single-select
          :value.sync="expense.apportionment"
          :value-property="'value'"
          :options="apportionmentOpt"
          :placeholder="'Selecione o rateio'"
        />
      </b-form-group>
      <b-form-group
        label="Tipo de rateio"
        label-for="input-typeOfApportionment"
      >
        <single-select
          :value.sync="expense.typeOfApportionment"
          :value-property="'value'"
          :options="typeOfApportionmentOpt"
          :placeholder="'Selecione o tipo de rateio'"
        />
      </b-form-group>
    </div>
    <div>
      <b-form-group label="Perfis" label-for="input-expenseProfiles">
        <multiselect
          id="selectSteps"
          class="select-field"
          v-model="expense.expenseProfiles"
          label="text"
          track-by="value"
          placeholder="Selecione os perfis"
          :close-on-select="false"
          :showLabels="false"
          :multiple="true"
          :options="prfilesOpt"
        >
        </multiselect>
      </b-form-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpenseCrud",
  props: {
    expense: Object,
  },
  components: {
    BaseInputNumeric: () =>
      import("@/components_rms/base/BaseInputNumeric.vue"),
    "cost-center-dropdown": () =>
      import("@/components_rms/System/CostCenter/CostCenterDropdown.vue"),
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
  },
  created() {
    this.getAllProfileOptions();
  },
  computed: {},
  data() {
    return {
      expenseTypeOpt: [
        { value: 1, text: "Variável" },
        { value: 2, text: "Fixa" },
      ],
      apportionmentOpt: [
        { value: 1, text: "Diário" },
        { value: 2, text: "Semanal" },
        { value: 3, text: "BiSemanal" },
        { value: 4, text: "Mensal" },
        { value: 5, text: "Anual" },
      ],
      typeOfApportionmentOpt: [
        { value: 1, text: "Veiculo" },
        { value: 2, text: "Motorista" },
      ],
      costCenterOpt: [{ value: 0, text: "" }],
      profiles: [],
      prfilesOpt: [],
    };
  },
  methods: {
    getAllProfileOptions() {
      this.$apiScheduler.get("/profile/getAll/").then((response) => {
        this.prfilesOpt = response.data;
      });
    },
  },
  mounted() {
    // Lifecycle hook
  },
};
</script>

<style scoped>
/* Your styles here */
</style>